module.exports = __webpack_public_path__ + "files/1a4b5e342caedad658d2855fc4880bf5.png";